import axiosInstance from "../../../axios";
import config from "../../../config";
import { usePersistedStore } from "../../persisted-store";

export const createCallItemsSlice = (set, get) => ({
    crmCallItems: {
        loading: false,
        data: [],
    },
    postCrmCallItems: async (param) => {
        const { params, callHistoryId } = param;
        const token = usePersistedStore.getState().business.currentBusiness.token;
        set(state => ({ crmCallItems: { ...state.crmCallItems, loading: true } }));
        try {
            const resp = await axiosInstance({
                method: "post",
                baseURL: config.apiUrls(),
                url: `/v1/crm/call-history-item/${callHistoryId}`,
                data: params,
                headers: { token },
            });
            set(state => ({ crmCallItems: { loading: false, data: resp.data } }));
        } catch (error) {
            set(state => ({ crmCallItems: { ...state.crmCallItems, loading: false } }));
        }
    }
});
